import { ajax } from "rxjs/ajax";
import apiHosts from "../constants/apiHosts";
import PendoConsts from "../constants/pendoConsts";

const version = "/v1";

const apiEndpoint = () => {
  const match = window.location.hostname.match(/(qa|stage)/);
  // console.log(match, 'match111')
  const host = match
    ? apiHosts[match[1]]
    : window.location.hostname === "one.redhat.com"
    ? apiHosts["prod"]
    : apiHosts["dev"];
  return host + version;
};

// const apiEndpoint = () => {
//   return `${window.origin}/api${version}`;
// };

const defaultHeaders = {
  "Content-Type": "application/json",
  // Authorization: "Bearer " + localStorage.getItem("token"),
};

export function getJSON(path, headers) {
  const fullHeaders = {
    ...defaultHeaders,
    ...headers,
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  return ajax.getJSON(`${apiEndpoint()}${path}`, fullHeaders);
}

export function postJSON(path, body, headers) {
  const fullHeaders = {
    ...defaultHeaders,
    ...headers,
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  return ajax.post(`${apiEndpoint()}${path}`, body, fullHeaders);
}

export function putJSON(path, body, headers) {
  const fullHeaders = {
    ...defaultHeaders,
    ...headers,
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  return ajax.put(`${apiEndpoint()}${path}`, body, fullHeaders);
}

export function deleteJSON(path, headers) {
  const fullHeaders = {
    ...defaultHeaders,
    ...headers,
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  return ajax.delete(`${apiEndpoint()}${path}`, fullHeaders);
}

export function fetchPendoData(eventType, eventId, startTime, endTime) {
  let data = {
    response: {
      mimeType: "application/json",
    },
    request: {
      pipeline: [
        {
          source: {
            timeSeries: {
              period: "hourRange",
              first: startTime,
              last: endTime,
            },
          },
        },
      ],
    },
  };

  if ("pageEvents" === eventType) {
    data.request.pipeline[0].source = {
      ...data.request.pipeline[0].source,
      pageEvents: {
        pageId: eventId,
        blacklist: "ignore",
      },
    };
  }

  if ("trackEvents" === eventType) {
    data.request.pipeline[0].source = {
      ...data.request.pipeline[0].source,
      trackEvents: {
        trackTypeId: eventId,
        blacklist: "ignore",
      },
    };
  }

  return fetch(PendoConsts.aggregationEndpoint, {
    body: JSON.stringify(data), // must match 'Content-Type' header
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, same-origin, *omit
    headers: {
      "content-type": "application/json",
      "x-pendo-integration-key": PendoConsts.integrationKey,
    },
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, cors, *same-origin
    redirect: "follow", // manual, *follow, error
    referrer: "no-referrer", // *client, no-referrer
  }).then((response) => response.json()); // parses response to JSON
}
